function fromYearConverter({year, month, day}) {
  return `${year}/${month}/${day}`
}

function fromDayConverter({year, month, day}) {
  return `${day}/${month}/${year}`
}

export default function(date, format) {
  let formattedDate
  const fullDate = new Date(date)
  const year = fullDate.getFullYear()
  let month = fullDate.getMonth() + 1
  if (month < 10) {
    month = `0${month}`
  }
  let day = fullDate.getDate()
  if (day < 10) {
    day = `0${day}`
  }

  if (format === 'YYYY/MM/DD') {
    formattedDate = fromYearConverter({ year, month, day })
  }
  if (format === 'DD/MM/YYYY') {
    formattedDate = fromDayConverter({ year, month, day })
  }
  return formattedDate
}



// WEBPACK FOOTER //
// ./src/pkg/date-formatter.js